import React from 'react';

const GitHubActivity = () => {
  return (
    <div className="bg-[#2D2A6B]/5 backdrop-blur-sm rounded-lg p-6">
      <h3 className="text-xl font-bold text-indigo-800 mb-4">Mes Contributions GitHub</h3>
      <div className="w-full overflow-hidden">
        <img
          src={`https://ghchart.rshah.org/2D2A6B/MLB-78`}
          alt="GitHub Contributions Graph"
          className="w-full h-auto"
        />
      </div>
      <div className="mt-4 text-center">
        <a
          href="https://github.com/MLB-78"
          target="_blank"
          rel="noopener noreferrer"
          className="text-indigo-600 hover:text-indigo-800 transition-colors text-sm"
        >
          Voir mon profil GitHub
        </a>
      </div>
    </div>
  );
};

export default GitHubActivity; 